import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { motion } from './motionCssCompNode'
import { motionCssDomApplier } from './motionCssDomApplier'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'
import type { MotionCssFeature } from './motionCss.types'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'

export const motionCssFeature: MotionCssFeature = {
	featureName: 'motion',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { motion },
	intermediateNodes: { hasResponsiveLayout: compInfoNodes.hasResponsiveLayout },
	dataMaps: ['effects'],
	domApplier: motionCssDomApplier,
	parentMediaRule: 'prefers-reduced-motion: no-preference',
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(motionCssFeature)
}
export const editor: BindFeature = page
